export const sampleType = {
  USED: 'used',
  NEW: 'new',
  RECONDICIONED: 'recondicioned',
  REGENERATED: 'regenerated',
  UNDEFINED: 'undefined',
};

export const samplingMoment = {
  BEFORE_FILLING: 'before-filling',
  AFTER_FILLING: 'after-filling',
};

export const visualAspect = {
  CLEAR: false,
  WITH_PARTICLES: true,
};
